var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "boss-admin-sidemenu-container",
      class: {
        "is-opened": _vm.isOpened,
        "boss-menu-close": !_vm.expandsSidebar,
      },
      attrs: { "data-test": "expand" },
    },
    [
      _c(
        "div",
        {
          staticClass: "boss-admin-sidemenu-toggle",
          on: {
            click: function ($event) {
              return _vm.toggle()
            },
          },
        },
        [
          _c("div", { staticClass: "boss-admin-sidemenu-toggle-bar" }),
          _vm._v(" "),
          _c("div", {
            staticClass:
              "boss-admin-sidemenu-toggle-bar boss-admin-sidemenu-toggle-bar-2",
          }),
          _vm._v(" "),
          _c("div", {
            staticClass:
              "boss-admin-sidemenu-toggle-bar boss-admin-sidemenu-toggle-bar-3",
          }),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "boss-admin-sidemenu-wrap" }, [
        _c("nav", { staticClass: "boss-admin-sidemenu" }, [
          _c(
            "ul",
            {
              staticClass: "vertical dropdown menu boss-admin-sidemenu-list",
              attrs: { id: "boss-dropdown-control", "data-dropdown-menu": "" },
            },
            [
              _c(
                "li",
                { staticClass: "boss-admin-sidemenu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "boss-admin-sidemenu-link",
                      class: {
                        "boss-active": _vm.$route.path.includes("/dashboard"),
                      },
                      attrs: {
                        to: { name: "dashboardTop" },
                        "data-test": "dashboard-top",
                        "exact-active-class": "boss-active",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "boss-menu-icon boss-menu-icon-dash" },
                        [
                          _c("span", {
                            staticClass: "boss-icon boss-icon-dashboard",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "boss-menu-name" }, [
                        _vm._v("\n              ダッシュボード\n            "),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.showEntry
                ? _c(
                    "li",
                    {
                      staticClass: "boss-admin-sidemenu-item",
                      attrs: { "data-test": "entry-sidemenu-link" },
                    },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "boss-admin-sidemenu-link",
                          class: {
                            "boss-active": _vm.$route.path.includes("/entries"),
                          },
                          attrs: {
                            to: { name: "entryTop" },
                            "data-test": "entry-top",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "boss-menu-icon boss-menu-icon-apply",
                            },
                            [
                              _c("span", {
                                staticClass: "boss-icon boss-icon-apply",
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "boss-menu-name" }, [
                            _vm._v("\n              応募者管理\n            "),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showScout
                ? _c(
                    "li",
                    {
                      staticClass: "boss-admin-sidemenu-item",
                      attrs: { "data-test": "scout-sidemenu-link" },
                    },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "boss-admin-sidemenu-link",
                          class: {
                            "boss-active": _vm.$route.path.includes("/scouts"),
                          },
                          attrs: {
                            to: { name: "scoutTop" },
                            "exact-active-class": "boss-active",
                            "data-test": "scout-and-liked",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "boss-menu-icon boss-menu-icon-scoutandlike",
                            },
                            [
                              _c("span", {
                                staticClass: "boss-icon boss-icon-scoutandlike",
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "boss-menu-name" }, [
                            _vm._v("\n              スカウト\n            "),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isExistsSeminar
                ? _c(
                    "li",
                    {
                      staticClass: "boss-admin-sidemenu-item",
                      attrs: { "data-test": "seminar-sidemenu-link" },
                    },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "boss-admin-sidemenu-link",
                          class: {
                            "boss-active":
                              _vm.$route.path.includes("/seminar_entries"),
                          },
                          attrs: {
                            to: { name: "seminarEntryTop" },
                            "data-test": "seminar-entry-top",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "boss-menu-icon boss-menu-icon-seminar",
                            },
                            [
                              _c("span", {
                                staticClass: "boss-icon boss-icon-seminar",
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "boss-menu-name" }, [
                            _vm._v(
                              "\n              セミナー管理\n            "
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("li", { staticClass: "boss-admin-sidemenu-item" }, [
                _c(
                  "span",
                  {
                    staticClass: "boss-admin-sidemenu-link",
                    class: {
                      "boss-active":
                        _vm.$route.path.includes("/job_confirmation"),
                    },
                  },
                  [_vm._m(0), _vm._v(" "), _vm._m(1)]
                ),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "vertical menu nested boss-side-submenu" },
                  [
                    _c(
                      "li",
                      { staticClass: "boss-side-submenu-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "boss-submenu-link",
                            attrs: {
                              to: { name: "jobPrePublished" },
                              "data-test": "job-pre-published",
                            },
                          },
                          [
                            _vm._v(
                              "\n                掲載前の求人\n              "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "boss-side-submenu-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "boss-submenu-link",
                            attrs: {
                              to: { name: "jobPublished" },
                              "data-test": "job-published",
                            },
                          },
                          [
                            _vm._v(
                              "\n                掲載済みの求人・応募フォームタイプ設定\n              "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "boss-admin-sidemenu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "boss-admin-sidemenu-link",
                      class: {
                        "boss-active":
                          _vm.$route.path.includes("/real_intentions"),
                      },
                      attrs: {
                        to: { name: "realIntentionTop" },
                        "data-test": "real-intention",
                      },
                    },
                    [
                      _c("div", { staticClass: "boss-menu-icon" }, [
                        _c("span", {
                          staticClass:
                            "boss-icon boss-icon-comment-dots-regular pega-icon-reputation-from-employees",
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "boss-menu-name" }, [
                        _vm._v("\n              社員からの評判\n            "),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "boss-admin-sidemenu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "boss-admin-sidemenu-link",
                      class: {
                        "boss-active": _vm.$route.path.includes(
                          "/interview_information"
                        ),
                      },
                      attrs: {
                        to: { name: "interviewInformationTop" },
                        "data-test": "interview",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "boss-menu-icon boss-menu-icon-interview",
                        },
                        [
                          _c("span", {
                            staticClass: "boss-icon boss-icon-interview",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "boss-menu-name" }, [
                        _vm._v("\n              面接情報\n            "),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "boss-admin-sidemenu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "boss-admin-sidemenu-link",
                      class: {
                        "boss-active": _vm.$route.path.includes(
                          "/interview_candidate"
                        ),
                      },
                      attrs: {
                        to: { name: "interviewCandidateDateTop" },
                        "data-test": "first-interview-candidate-date",
                      },
                    },
                    [
                      _c("div", { staticClass: "boss-menu-icon" }, [
                        _c("span", {
                          staticClass:
                            "boss-icon boss-icon-calendar-check-regular pega-icon-first-interview-candidate-date",
                        }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "boss-menu-name pega-side-menu-first-interview-candidate-date",
                        },
                        [
                          _vm._v(
                            "\n              一次面接候補日設定\n            "
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("li", { staticClass: "boss-admin-sidemenu-item" }, [
                _c(
                  "span",
                  {
                    staticClass: "boss-admin-sidemenu-link",
                    class: {
                      "boss-active": _vm.$route.path.includes("/settings"),
                    },
                  },
                  [_vm._m(2), _vm._v(" "), _vm._m(3)]
                ),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "vertical menu nested boss-side-submenu" },
                  [
                    _vm.showAccounts
                      ? _c(
                          "li",
                          {
                            staticClass: "boss-side-submenu-item",
                            attrs: { "data-test": "account-sidemenu-link" },
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "boss-submenu-link",
                                attrs: {
                                  to: { name: "settingAccounts" },
                                  "data-test": "setting-accounts",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                アカウント管理\n              "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showAllowedIpAddress
                      ? _c(
                          "li",
                          {
                            staticClass: "boss-side-submenu-item",
                            attrs: { "data-test": "ip-address-sidemenu-link" },
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "boss-submenu-link",
                                attrs: {
                                  to: { name: "settingIpAddress" },
                                  "data-test": "ip-address",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                閲覧制限用IPアドレス設定\n              "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "boss-side-submenu-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "boss-submenu-link",
                            attrs: {
                              to: { name: "settingScoutTemplates" },
                              "data-test": "scout-template",
                            },
                          },
                          [
                            _vm._v(
                              "\n                スカウト＿テンプレート設定\n              "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "boss-side-submenu-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "boss-submenu-link",
                            attrs: {
                              to: { name: "settingMemberAttributes" },
                              "data-test": "member-attributes",
                            },
                          },
                          [
                            _vm._v(
                              "\n                スカウト＿一覧画面の表示情報の設定\n              "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.showSettingsSelection
                      ? _c(
                          "li",
                          {
                            staticClass: "boss-side-submenu-item",
                            attrs: { "data-test": "selection-sidemenu-link" },
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "boss-submenu-link",
                                attrs: {
                                  to: { name: "settingSelections" },
                                  "data-test": "screening-process",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                応募者管理＿選考フェーズ・ステータス設定\n              "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "boss-side-submenu-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "boss-submenu-link",
                            attrs: {
                              to: { name: "settingMessageTemplates" },
                              "data-test": "message-template",
                            },
                          },
                          [
                            _vm._v(
                              "\n                応募者管理＿テンプレート設定\n              "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "boss-side-submenu-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "boss-submenu-link",
                            attrs: {
                              to: { name: "settingEntryColumns" },
                              "data-test": "setting-entry-columns",
                            },
                          },
                          [
                            _vm._v(
                              "\n                応募者管理＿一覧画面の表示情報の設定\n              "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "boss-side-submenu-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "boss-submenu-link",
                            attrs: {
                              to: { name: "settingEntryAutoReply" },
                              "data-test": "setting-entry-auto-reply",
                            },
                          },
                          [
                            _vm._v(
                              "\n                応募者管理＿自動受付メッセージ設定\n              "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _vm._m(4),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "boss-admin-sidemenu-openandclose",
            attrs: { "data-test": "menu-open-and-close" },
            on: { click: _vm.menuOpenClose },
          },
          [_vm._m(5)]
        ),
        _vm._v(" "),
        _c("div", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.expandsSidebar,
              expression: "expandsSidebar",
            },
          ],
          attrs: { "data-test": "information-second" },
          domProps: { innerHTML: _vm._s(_vm.informationSecond) },
        }),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "boss-menu-icon boss-menu-icon-posting" }, [
      _c("span", { staticClass: "boss-icon boss-icon-posting" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "boss-menu-name" }, [
      _vm._v("求人確認"),
      _c("span", { staticClass: "boss-icon-triangle" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "boss-menu-icon boss-menu-icon-setting" }, [
      _c("span", { staticClass: "boss-icon boss-icon-setting" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "boss-menu-name" }, [
      _vm._v("各種設定"),
      _c("span", { staticClass: "boss-icon-triangle" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "boss-admin-sidemenu-item" }, [
      _c(
        "a",
        {
          staticClass: "boss-admin-sidemenu-link",
          attrs: {
            target: "_blank",
            "data-test": "user-help",
            href: "/help/index.html",
          },
        },
        [
          _c("div", { staticClass: "boss-menu-icon boss-menu-icon-apply" }, [
            _c("span", { staticClass: "boss-icon boss-icon-question" }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "boss-menu-name" }, [
            _vm._v("ユーザーガイド"),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "boss-admin-sidemenu-link" }, [
      _c("div", { staticClass: "boss-menu-icon boss-menu-icon-open" }, [
        _c("span", { staticClass: "boss-icon boss-icon-close" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "boss-menu-name" }, [
        _vm._v("メニューを閉じる"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }